import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=4bdfa034&scoped=true&"
import script from "./Overdue.vue?vue&type=script&async=true&lang=js&"
export * from "./Overdue.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Overdue.vue?vue&type=style&index=0&id=4bdfa034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfa034",
  null
  
)

export default component.exports